export const extensions = [
  {
    name: "Grammarly",
    category: "Productivity",
    description:
      "AI-powered writing assistant that helps with grammar, spelling, and style. Freemium model with premium subscriptions.",
    revenue: "$200M+/year",
    revenueModel: "Freemium",
    users: "30M+",
    rating: "4.6",
    age: "12+ years",
    growth: "Steady",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/grammarly",
  },
  {
    name: "Honey",
    category: "Shopping",
    description:
      "Automatic coupon finder and price tracker. Acquired by PayPal for $4 billion. Commission-based revenue model.",
    revenue: "$4B exit",
    revenueModel: "Affiliate",
    users: "17M+",
    rating: "4.7",
    age: "10+ years",
    growth: "Acquired",
    filterTag: "shopping",
    link: "https://chromewebstore.google.com/detail/honey",
  },
  {
    name: "Calendly",
    category: "Productivity",
    description:
      "Automated scheduling tool that eliminates back-and-forth emails. Premium plans for individuals and teams.",
    revenue: "$100M+ ARR",
    revenueModel: "Freemium",
    users: "10M+",
    rating: "4.6",
    age: "8 years",
    growth: "+50% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/calendly",
  },
  {
    name: "Notion Web Clipper",
    category: "Productivity",
    description:
      "Save web content directly to Notion workspace. Part of Notion's $10B+ valuation ecosystem.",
    revenue: "$300M+ ARR",
    revenueModel: "Freemium",
    users: "8M+",
    rating: "4.5",
    age: "5 years",
    growth: "+100% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/notion-web-clipper",
  },
  {
    name: "Loom",
    category: "Productivity",
    description:
      "Video messaging tool for work. Freemium model with team subscriptions. Valued at $1.5 billion.",
    revenue: "$100M+ ARR",
    revenueModel: "Freemium",
    users: "14M+",
    rating: "4.7",
    age: "7 years",
    growth: "+150% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/loom",
  },
  {
    name: "Dashlane",
    category: "Security",
    description:
      "Password manager with VPN and dark web monitoring. Premium subscriptions starting at $4.99/month.",
    revenue: "$60M+/year",
    revenueModel: "Freemium",
    users: "15M+",
    rating: "4.3",
    age: "11 years",
    growth: "Stable",
    filterTag: "security",
    link: "https://chromewebstore.google.com/detail/dashlane",
  },
  {
    name: "LastPass",
    category: "Security",
    description:
      "Password manager with encrypted vault. Premium subscriptions for advanced features and family plans.",
    revenue: "$80M+/year",
    revenueModel: "Freemium",
    users: "25M+",
    rating: "4.4",
    age: "15+ years",
    growth: "Stable",
    filterTag: "security",
    link: "https://chromewebstore.google.com/detail/lastpass",
  },
  {
    name: "Evernote Web Clipper",
    category: "Productivity",
    description:
      "Save web articles, screenshots, and PDFs to Evernote. Part of Evernote's freemium ecosystem.",
    revenue: "$120M+/year",
    revenueModel: "Freemium",
    users: "10M+",
    rating: "4.5",
    age: "13 years",
    growth: "Stable",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/evernote-web-clipper",
  },
  {
    name: "Scribe",
    category: "Productivity",
    description:
      "Automatically creates step-by-step guides with screenshots. Premium plans for teams and enterprises.",
    revenue: "$10M+/year",
    revenueModel: "Freemium",
    users: "1M+",
    rating: "4.8",
    age: "3 years",
    growth: "+200% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/scribe",
  },
  {
    name: "Speechify",
    category: "Accessibility",
    description:
      "Text-to-speech for web content and documents. Premium subscriptions at $11.58/month.",
    revenue: "$30M+/year",
    revenueModel: "Freemium",
    users: "5M+",
    rating: "4.5",
    age: "6 years",
    growth: "+80% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/speechify",
  },
  {
    name: "ColorZilla",
    category: "Developer Tools",
    description:
      "Color picker and eyedropper tool for designers and developers. Ad-supported with premium features.",
    revenue: "$500K+/year",
    revenueModel: "Ads + Pro",
    users: "3M+",
    rating: "4.6",
    age: "15+ years",
    growth: "Stable",
    filterTag: "tools",
    link: "https://chromewebstore.google.com/detail/colorzilla",
  },
  {
    name: "Wappalyzer",
    category: "Developer Tools",
    description:
      "Identifies technologies used on websites. Freemium with Pro plans for lead generation and API access.",
    revenue: "$3M+/year",
    revenueModel: "Freemium",
    users: "2M+",
    rating: "4.6",
    age: "10 years",
    growth: "+35% YoY",
    filterTag: "tools",
    link: "https://chromewebstore.google.com/detail/wappalyzer",
  },
  {
    name: "JSONView",
    category: "Developer Tools",
    description:
      "Formats JSON data for easy reading. Donation-supported open-source project.",
    revenue: "$100K+/year",
    revenueModel: "Donations",
    users: "1M+",
    rating: "4.7",
    age: "12 years",
    growth: "Stable",
    filterTag: "tools",
    link: "https://chromewebstore.google.com/detail/jsonview",
  },
  {
    name: "Rakuten",
    category: "Shopping",
    description:
      "Cash back rewards for online shopping. Earns commission from retailers and shares with users.",
    revenue: "$200M+/year",
    revenueModel: "Affiliate",
    users: "12M+",
    rating: "4.5",
    age: "8 years",
    growth: "+40% YoY",
    filterTag: "shopping",
    link: "https://chromewebstore.google.com/detail/rakuten",
  },
  {
    name: "Capital One Shopping",
    category: "Shopping",
    description:
      "Automatic coupon finder and price comparison tool. Affiliate commission model similar to Honey.",
    revenue: "$150M+/year",
    revenueModel: "Affiliate",
    users: "10M+",
    rating: "4.6",
    age: "6 years",
    growth: "+60% YoY",
    filterTag: "shopping",
    link: "https://chromewebstore.google.com/detail/capital-one-shopping",
  },
  {
    name: "Keepa",
    category: "Shopping",
    description:
      "Amazon price tracker with historical charts. Premium subscriptions for advanced features and alerts.",
    revenue: "$8M+/year",
    revenueModel: "Freemium",
    users: "2M+",
    rating: "4.7",
    age: "9 years",
    growth: "+25% YoY",
    filterTag: "shopping",
    link: "https://chromewebstore.google.com/detail/keepa",
  },
  {
    name: "Momentum",
    category: "Productivity",
    description:
      "Personal dashboard for new tabs with focus tools. Freemium with Plus subscription at $3.33/month.",
    revenue: "$5M+/year",
    revenueModel: "Freemium",
    users: "3M+",
    rating: "4.8",
    age: "9 years",
    growth: "+25% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/momentum",
  },
  {
    name: "Forest",
    category: "Productivity",
    description:
      "Gamified focus timer that plants virtual trees. Premium features and real tree planting partnerships.",
    revenue: "$4M+/year",
    revenueModel: "Freemium",
    users: "2M+",
    rating: "4.7",
    age: "8 years",
    growth: "+30% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/forest",
  },
  {
    name: "Todoist",
    category: "Productivity",
    description:
      "Task management and to-do list organizer. Premium and Business subscriptions with advanced features.",
    revenue: "$20M+/year",
    revenueModel: "Freemium",
    users: "5M+",
    rating: "4.5",
    age: "11 years",
    growth: "+30% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/todoist",
  },
  {
    name: "Toggl Track",
    category: "Productivity",
    description:
      "Time tracking for freelancers and teams. Premium plans with reporting and integrations.",
    revenue: "$25M+/year",
    revenueModel: "Freemium",
    users: "4M+",
    rating: "4.6",
    age: "12 years",
    growth: "+20% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/toggl-track",
  },
  {
    name: "AdBlock",
    category: "Privacy",
    description:
      "Blocks ads and trackers. Generates revenue through acceptable ads program and donations.",
    revenue: "$50M+/year",
    revenueModel: "Acceptable Ads",
    users: "60M+",
    rating: "4.6",
    age: "13+ years",
    growth: "Stable",
    filterTag: "privacy",
    link: "https://chromewebstore.google.com/detail/adblock",
  },
  {
    name: "Ghostery",
    category: "Privacy",
    description:
      "Tracker blocker and privacy tool. Revenue from data insights (anonymized) and premium subscriptions.",
    revenue: "$15M+/year",
    revenueModel: "Data + Premium",
    users: "8M+",
    rating: "4.4",
    age: "14 years",
    growth: "Stable",
    filterTag: "privacy",
    link: "https://chromewebstore.google.com/detail/ghostery",
  },
  {
    name: "Privacy Badger",
    category: "Privacy",
    description:
      "Automatic tracker blocker by EFF. Non-profit, donation-funded privacy tool.",
    revenue: "$200K+/year",
    revenueModel: "Donations",
    users: "3M+",
    rating: "4.6",
    age: "9 years",
    growth: "Stable",
    filterTag: "privacy",
    link: "https://chromewebstore.google.com/detail/privacy-badger",
  },
  {
    name: "Boomerang for Gmail",
    category: "Productivity",
    description:
      "Email scheduling and follow-up reminders for Gmail. Freemium with premium plans for power users.",
    revenue: "$6M+/year",
    revenueModel: "Freemium",
    users: "2M+",
    rating: "4.5",
    age: "12 years",
    growth: "+15% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/boomerang-for-gmail",
  },
  {
    name: "Apollo.io",
    category: "Sales",
    description:
      "B2B sales intelligence and email finder. Enterprise subscriptions for sales teams.",
    revenue: "$100M+ ARR",
    revenueModel: "Freemium",
    users: "1M+",
    rating: "4.4",
    age: "7 years",
    growth: "+120% YoY",
    filterTag: "business",
    link: "https://chromewebstore.google.com/detail/apollo",
  },
  {
    name: "Hunter",
    category: "Sales",
    description:
      "Email finder and verification tool for professionals. Freemium with paid tiers for bulk searches.",
    revenue: "$12M+/year",
    revenueModel: "Freemium",
    users: "3M+",
    rating: "4.5",
    age: "9 years",
    growth: "+40% YoY",
    filterTag: "business",
    link: "https://chromewebstore.google.com/detail/hunter",
  },
  {
    name: "StayFocusd",
    category: "Productivity",
    description:
      "Website blocker for productivity. Free with donations. Simple but effective focus tool.",
    revenue: "$150K+/year",
    revenueModel: "Donations",
    users: "900K+",
    rating: "4.4",
    age: "13 years",
    growth: "Stable",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/stayfocusd",
  },
  {
    name: "Nimbus Screenshot",
    category: "Productivity",
    description:
      "Screen capture and video recording tool. Freemium with premium plans for enhanced features.",
    revenue: "$2M+/year",
    revenueModel: "Freemium",
    users: "1.5M+",
    rating: "4.6",
    age: "10 years",
    growth: "+20% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/nimbus-screenshot",
  },
  {
    name: "Mixmax",
    category: "Sales",
    description:
      "Email tracking, templates, and scheduling for sales teams. Premium subscriptions for professionals.",
    revenue: "$18M+/year",
    revenueModel: "Freemium",
    users: "800K+",
    rating: "4.6",
    age: "9 years",
    growth: "+35% YoY",
    filterTag: "business",
    link: "https://chromewebstore.google.com/detail/mixmax",
  },
  {
    name: "Clearbit Connect",
    category: "Sales",
    description:
      "B2B contact information finder in Gmail. Part of Clearbit's enterprise data platform.",
    revenue: "$50M+/year",
    revenueModel: "Enterprise",
    users: "500K+",
    rating: "4.3",
    age: "8 years",
    growth: "+25% YoY",
    filterTag: "business",
    link: "https://chromewebstore.google.com/detail/clearbit-connect",
  },
  {
    name: "Liner",
    category: "Research",
    description:
      "Web highlighter and research tool with AI summarization. Freemium with premium AI features.",
    revenue: "$3M+/year",
    revenueModel: "Freemium",
    users: "1M+",
    rating: "4.7",
    age: "6 years",
    growth: "+70% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/liner",
  },
  {
    name: "Soapbox by Wistia",
    category: "Video",
    description:
      "Quick video creation tool with screen and webcam recording. Free tool by Wistia to drive platform adoption.",
    revenue: "$500K+/year",
    revenueModel: "Lead Gen",
    users: "600K+",
    rating: "4.5",
    age: "5 years",
    growth: "+50% YoY",
    filterTag: "productivity",
    link: "https://chromewebstore.google.com/detail/soapbox",
  },
  {
    name: "Vidyard",
    category: "Sales",
    description:
      "Video messaging for sales and support teams. Freemium with enterprise plans for businesses.",
    revenue: "$40M+/year",
    revenueModel: "Freemium",
    users: "700K+",
    rating: "4.7",
    age: "7 years",
    growth: "+45% YoY",
    filterTag: "business",
    link: "https://chromewebstore.google.com/detail/vidyard",
  },
];
